import { useEffect, useState } from 'react';

import useStripe from 'hooks/useStripe';

const useData = () => {
    const [customerSessionSecret, setCustomerSessionSecret] = useState<string | undefined>();
    const [pricingTableId, setPricingTableId] = useState<string | undefined>();
    const { fetchCustomerSessionSecret } = useStripe();

    const getCustomerSecret = async () => {
        const session = await fetchCustomerSessionSecret();

        setCustomerSessionSecret(session?.customerSecret);
        setPricingTableId(session?.pricingTableId);
    };

    useEffect(() => {
        getCustomerSecret();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        customerSessionSecret,
        pricingTableId
    };
};

export default useData;
